import { useState, useEffect } from 'react'
import { api } from '../api/client.js'

export interface AuditLogActor {
  id: string
  name: string
  email: string
  type: 'user' | 'platform_admin'
}

export function useAuditLogActors() {
  const [actors, setActors] = useState<AuditLogActor[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    async function fetchActors() {
      try {
        setLoading(true)
        const response = await api.get<{ actors: AuditLogActor[] }>('/admin/compliance/audit-log/actors')
        setActors(response.actors)
        setError(null)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to fetch actors')
      } finally {
        setLoading(false)
      }
    }

    void fetchActors()
  }, [])

  return { actors, loading, error }
}
